import Image from 'components/image/Image';

import { ICtaLink } from 'source/NFR.types';

const CtaLink: React.FC<ICtaLink> = ({ image, text, url }) => (
  <a href={url} className="cta-link">
    <Image {...image} responsive={false} />
    <span>{text}</span>
  </a>
);

CtaLink.displayName = 'CtaLink';

export default CtaLink;
